import React from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import { aiProactiveMessages } from '@atlaskit/editor-common/ai-messages';
import Heading from '@atlaskit/heading';
import Image from '@atlaskit/image';
import { Stack, Text } from '@atlaskit/primitives/compiled';

import ReloadSuggestionsImageDark from '../assets/reload-suggestions/dark.svg';
import ReloadSuggestionsImageLight from '../assets/reload-suggestions/light.svg';

export const ReloadSuggestionsState = ({
	handleReloadSuggestions,
	isEditorDisabled,
}: {
	handleReloadSuggestions: () => void;
	isEditorDisabled?: boolean;
}) => {
	const { formatMessage } = useIntl();
	<Image src={ReloadSuggestionsImageLight} srcDark={ReloadSuggestionsImageDark} />;

	return (
		<Stack space="space.200" alignInline="center" grow="fill">
			<Image src={ReloadSuggestionsImageLight} srcDark={ReloadSuggestionsImageDark} />
			<Stack space="space.200" alignInline="center">
				<Heading color="color.text" size="small">
					{formatMessage(aiProactiveMessages.reloadSuggestionsStateTitle)}
				</Heading>
				<Text align="center" color="color.text" size="medium">
					{formatMessage(aiProactiveMessages.reloadSuggestionsStateDescription)}
				</Text>
				<Button
					appearance="default"
					onClick={handleReloadSuggestions}
					isDisabled={isEditorDisabled}
				>
					{formatMessage(aiProactiveMessages.reloadSuggestionsButtonLabel)}
				</Button>
			</Stack>
		</Stack>
	);
};
